import React, { useEffect } from 'react';
import Section from '../components/Section';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="pt-20 bg-white">
        <Section>
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-zinc-950 mb-4">
              Privacy Policy
            </h1>
            <p className="text-zinc-500 mb-12 italic">Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

            <div className="prose prose-zinc max-w-none space-y-10 text-zinc-600">
              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">1. Introduction</h2>
                <p className="leading-relaxed">
                  At Data Risk Audit, your privacy is our core concern. This policy outlines how we handle your information. We only collect the minimal data required to perform our analysis and provide you with actionable insights.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">2. Information We Collect</h2>
                <p className="mb-4">We may collect the following information to provide our service:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Identity Data:</strong> Your name.</li>
                  <li><strong>Contact Data:</strong> Your email address.</li>
                  <li><strong>Audit Data:</strong> The list of apps you provide for analysis.</li>
                  <li><strong>Optional Context:</strong> Any specific concerns or your profession if shared.</li>
                </ul>
                <p className="mt-4 font-medium text-zinc-900">
                  Payment is processed securely via third-party providers (like Stripe). We do NOT store or see your payment details.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">3. How We Use Information</h2>
                <p className="mb-4">We use your information solely to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Deliver your personalized data risk audit.</li>
                  <li>Communicate with you regarding your report.</li>
                  <li>Improve our manual analysis methods.</li>
                </ul>
                <p className="mt-4 font-bold text-zinc-950">
                  We do NOT sell or share your personal data with third parties.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">4. Data Storage & Security</h2>
                <p className="leading-relaxed">
                  Your data is stored securely and used only internally by our audit team. We retain your information only as long as necessary to deliver the service, after which it is securely archived or deleted.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">5. Third-Party Services</h2>
                <p className="leading-relaxed">
                  We use Stripe for payments and Formspree for contact forms. These providers have their own privacy policies which govern how they handle your data on our behalf.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">6. User Rights</h2>
                <p className="leading-relaxed">
                  You can request the deletion of your data at any time. Simply contact us at the email below to exercise your rights or ask questions.
                </p>
              </section>

              <section className="pt-8 border-t border-zinc-100">
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">7. Contact</h2>
                <p className="leading-relaxed">
                  Email: <a href="mailto:hello@datariskaudit.com" className="font-bold text-zinc-950 hover:underline">hello@datariskaudit.com</a>
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">8. Updates</h2>
                <p className="leading-relaxed">
                  This policy may be updated occasionally. Substantial changes will be noted on this page.
                </p>
              </section>
            </div>
          </div>
        </Section>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;